import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { history } from "../..";
import { IPodiumData } from "../models/podium";
import { RootStore } from "./rootStore";
import { toast } from "react-toastify";

export default class PodiumStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  currentPodium: IPodiumData | null = null;
  validatingPin: boolean = false;

  loadPodiumData = async (meetingId: number, preview:boolean) => {
    try {
      if (preview){
        const dto= await agent.Podium.podiumDataPreview(meetingId, preview);
        runInAction(() => {
          this.currentPodium = dto;
        });
        return dto;
      }else{
        const {userStore} = this.rootStore;
        var userId= userStore.user?.id;
        // toast.info("userId:" + userId + " meetingId:" + meetingId + " preview:" + preview );
        const dto = await agent.Podium.podiumData(meetingId,userId??0);
        runInAction(() => {
          this.currentPodium = dto;
        });
        return dto;
    }
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
  loadPreview = async (meeting : string) => {
    
    const { company} = this.rootStore.commonStore;
     if (company) {
          const dto = await agent.Podium.previewByCode(company.id);
          runInAction(() => {
            this.currentPodium = dto;
          });
        
          return dto;
        }
      };
  validateSpeakerPin = async (speakerId: number, pin: string) => {
    this.validatingPin = true;
    try {
      let result = false;
      if (this.currentPodium)
        result = await agent.Podium.validatePin(
          this.currentPodium.id,
          speakerId,
          pin
        );
      runInAction(() => (this.validatingPin = false));
      return result;
    } catch (error) {
      runInAction(() => (this.validatingPin = false));
      throw error;
    }
  };

  podiumLogout = async (pwd: string) => {
    try {
      const allowLogout = await agent.Podium.validatePodiumLogout(pwd);
      if (allowLogout) history.push("/logout");
      else throw new Error("Wrong password");
    } catch (error) {
      throw error;
    }
  };

  loadSpeakerContent = async (meetingId: number, speakerId: number) => {
    const { commonStore } = this.rootStore;
    try {
      const dto = await agent.Podium.speakerContent(meetingId, speakerId);
      runInAction(() => {
        commonStore.setSpeakerBrowsePageContent(dto);
      });
    } catch (error) {
      throw error;
    }
  };

  showQRCode = async () => {
    try {
      await agent.Podium.showQrCode();
      console.log("QR Code button clicked")
    } catch (error) {}
  };

  showPodiumStandby = async () => {
    const { playerStore } = this.rootStore;
    try {
      if (playerStore.attendingMeeting) {
        //toast.success("Standby");
        await agent.Podium.showStandby(playerStore.attendingMeeting.id);
        console.log("Standby On/Off")
      }
    } catch (error) {}
  };

  resetPodiumData = () => {
    this.currentPodium = null;
  };
}
